import { useContactSectionContent } from './useContactSectionContent';
import { parseContactHeroContent } from '../utils/contactContent';

export const useContactHeroContent = () => useContactSectionContent(parseContactHeroContent);
